export const base_url = "https://api.childrenslanguageschool.com/admin";